import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export const authComputed = {
  ...mapGetters('authentication', ['loggedIn', 'getPermissions', 'getFullName', 'getOrganizationSetting'])
}

export const storeComputed = {
  ...mapGetters('stores', ['currentStoreUser', 'idCurrentStore'])
}

export const socketComputed = {
  ...mapGetters('socketNotifications', [
      'hasSocket', 
      'listNotifications', 
      'getSocket', 
      'countNotifications',
      'noveltyCount'
    ]
  )
}

export const packageMutation = mapMutations('package', ['setStatusPackingList', 'SET_STATUS_RELACION_DESPACHO'])

export const packageCompute = mapGetters('package', ['statusPackingList', 'hasProducts', 'statusRelacionDespacho', 'hasGuidesRelacionDespacho', 'getConveyorName'])

export const packageActions = mapActions('package', ['addProductsPacking', 'resetPackingList', 'addGuideRelacionDespacho', 'addConveyorRelacionDespacho', 'resetRelacionDespacho'])

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const authenticationMethods = mapActions('authentication', ['login', 'logout', 'organizationSettingAction'])

export const storeActions = mapActions('stores', ['changeStoreAction'])

export const socketActions = mapActions('socketNotifications', ['connectSocket'])

export const todoComputed = {
  ...mapState('todo', {
    todos: (state) => state.todos
  })
}
export const todoMethods = mapActions('todo', ['fetchTodos'])